import { render, staticRenderFns } from "./UpdateSchedules.vue?vue&type=template&id=460a2cd6"
import script from "./UpdateSchedules.vue?vue&type=script&lang=js"
export * from "./UpdateSchedules.vue?vue&type=script&lang=js"
import style0 from "./UpdateSchedules.vue?vue&type=style&index=0&id=460a2cd6&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('460a2cd6')) {
      api.createRecord('460a2cd6', component.options)
    } else {
      api.reload('460a2cd6', component.options)
    }
    module.hot.accept("./UpdateSchedules.vue?vue&type=template&id=460a2cd6", function () {
      api.rerender('460a2cd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/pop-up/UpdateSchedules.vue"
export default component.exports